export enum VersionStatus {
  Created = 'created',
  Preview = 'preview',
  Active = 'active',
  Blocked = 'blocked',
  Maintenance = 'maintenance',
  Deprecated = 'deprecated',
}
